import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: "gfu-skeleton-line",
    style: _normalizeStyle($options.style)
  }, null, 4 /* STYLE */))
}